const LAT_PARAM = 'lat';
const LNG_PARAM = 'lng';
const QUERY_PARAM = 'q';
// 5 decimals is roughly 1 meter precision
const PRECISION = 5;

export const getLocationFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    const lat = parseFloat(params.get(LAT_PARAM));
    const lng = parseFloat(params.get(LNG_PARAM));

    return Number.isFinite(lat) && Number.isFinite(lng)
        ? { lat, lng, query: params.get(QUERY_PARAM) || '' }
        : null;
};

// Query is the searched place name, empty when using geolocation
export const setLocationInUrl = (cords, query) => {
    const url = new URL(window.location.href);
    url.searchParams.set(LAT_PARAM, cords.lat().toFixed(PRECISION));
    url.searchParams.set(LNG_PARAM, cords.lng().toFixed(PRECISION));
    if (query) {
        url.searchParams.set(QUERY_PARAM, query);
    } else {
        url.searchParams.delete(QUERY_PARAM);
    }
    window.history.replaceState(window.history.state, '', url);
};
